<template>
  <div class="admin-component">
    <content-placeholder v-if="fetching">
      <el-card>
        <p class="text text-75"></p>
        <p class="text text-full"></p>
        <p class="text text-50"></p>
        <p class="text text-50"></p>
        <p class="text text-50"></p>
      </el-card>
    </content-placeholder>
    <el-card v-else>
      <div slot="header">Currently Clocked-In ({{today | formatTime('MMMM Do YYYY') }})</div>
      <el-table
        :data="timeLogs"
        style="width: 100%"
        :border="true"
        class="depth"
        v-if="timeLogs.length > 0">
        <el-table-column label="" width="58" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.user">
              <img :src="getGravatar(scope.row.user.email,'20')" class="thumbnail">
            </span>
          </template>
        </el-table-column>
        <el-table-column label="Email" sortable width="200">
          <template slot-scope="scope">
            <span v-if="scope.row.user">
              <span v-if="scope.row.user.profile">
                {{ scope.row.user.profile.first_name }}
                {{ scope.row.user.profile.last_name }}
              </span>
              <span v-else>
                {{ scope.row.user.email }}
              </span>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="Category" sortable prop="category.name"></el-table-column>
        <el-table-column label="Note" sortable prop="note"></el-table-column>
        <el-table-column label="Started At">
          <template slot-scope="scope">
            {{ scope.row.started_at | formatTime('LTS') }}
          </template>
        </el-table-column>
      </el-table>
      <div v-else>
        <el-alert type="info" :closable="false" title="No one is clocked in at the moment!" center></el-alert>
      </div>
    </el-card>
  </div>
</template>

<script>
  import avatar from '@/mixins/avatar';
  import moment from 'moment';
  import { mapGetters, mapActions } from 'vuex';

  export default {
    name: 'CurrentClockin',
    mixins: [avatar],
    created() {
      this.fetchUsers({ scope: 'employee' });
      this.fetchAllRunningTimeLog();
    },
    computed: {
      ...mapGetters('entities/timeLogs', ['fetching']),

      timeLogs() {
        return this.$store.getters['entities/timeLogs/query']()
          .with('category')
          .with('user')
          .with('user.profile')
          .where(record => record.stopped_at === null)
          .where('deleted', false)
          .get();
      },
      today() {
        return moment();
      },
    },
    methods: {
      ...mapActions('entities/users', ['fetchUsers']),

      fetchAllRunningTimeLog() {
        const params = {
          mode: 'day',
          day: this.today,
        };
        return this.$store.dispatch('entities/timeLogs/fetchAllRunningTimeLog', params);
      },
    },
  };
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/CurrentClockedin.vue